export default "__VITE_ASSET__Bv65Bs$7__"